// store/theme/actionTypes.js
export const TOGGLE_THEME = "TOGGLE_THEME";
